import moment from "moment";

export enum DateType {
  CURRENT = 0,
  TODAY = 1,
  TOMORROW = 2,
  YESTERDAY = 3,
  LAST_WEEK_DAY = 4,
  LAST_MONTH_DAY = 5,
  LAST_YEAR_DAY = 6,
}
export function GetUTCDateInISOString(
  dateString: string,
  endOfDay: boolean = true
) {
  var date = moment.utc(dateString, "YYYY-MM-DD HH:mm:ss");

  if (endOfDay) {
    date = date.endOf("day");
  }

  return date.toISOString().replace("T", " ").replace("Z", "");
}

export function GetUTCDateInISOStringFromLocalDateTime(
  dateString: string,
  endOfDay: boolean = true
) {
  var date = moment(dateString, "YYYY-MM-DD");

  if (endOfDay) {
    date = date.endOf("day");
  }

  return date.utc().toISOString().replace("T", " ").replace("Z", "");
}

export function GetLocalDateTimeInISOString(
  dateString: string,
  endOfDay: boolean = true
) {
  var date = moment(dateString, "YYYY-MM-DD");

  if (endOfDay) {
    date = date.endOf("day");
  }

  return date.toISOString();
}

export function GetUTCDateFromLocalDateTime(
  dateString: string
) {
  var date = moment(dateString);
  
  return date.utc().toISOString().replace("T", " ").replace("Z", "");
}

export function GetUTCDatetimeInISOString(
  dateType: DateType,
  endOfDay: boolean = false
) {
  var date = moment.utc();

  switch (dateType) {
    case DateType.CURRENT:
      return date.toISOString().replace("T", " ").replace("Z", "");
    case DateType.TODAY:
      break;
    case DateType.TOMORROW:
      date = date.add(1, "day");
      break;
    case DateType.YESTERDAY:
      date = date.subtract(1, "day");
      break;
    case DateType.LAST_WEEK_DAY:
      date = date.subtract(6, "day");
      break;
    case DateType.LAST_MONTH_DAY:
      date = date.subtract(1, "month").add(1, "day");
      break;
    case DateType.LAST_YEAR_DAY:
      date = date.subtract(1, "year").add(1, "day");
      break;
    default:
      break;
  }

  if (endOfDay) {
    date = date.endOf("day");
  } else {
    date = date.startOf("day");
  }

  return date.toISOString().replace("T", " ").replace("Z", "");
}

export function GetLocalDatetimeInISOString(
  dateType: DateType,
  endOfDay: boolean = false
) {
  var date = moment().local();

  switch (dateType) {
    case DateType.CURRENT:
    case DateType.TODAY:
      break;
    case DateType.TOMORROW:
      date = date.add(1, "day");
      break;
    case DateType.YESTERDAY:
      date = date.subtract(1, "day");
      break;
    case DateType.LAST_WEEK_DAY:
      date = date.subtract(6, "day");
      break;
    case DateType.LAST_MONTH_DAY:
      date = date.subtract(1, "month").add(1, "day");
      break;
    case DateType.LAST_YEAR_DAY:
      date = date.subtract(1, "year").add(1, "day");
      break;
    default:
      break;
  }

  if (endOfDay) {
    date = date.endOf("day");
  } else {
    date = date.startOf("day");
  }

  return date.toISOString();
}

export function GetLocalDatetime(utcDatetime: string) {
  utcDatetime = utcDatetime.replace("T", " ").replace("Z", "");
  return moment.utc(utcDatetime).local().format("YYYY-MM-DD HH:mm:ss");
}

export function GetShortDatetime(longDatetime: string) {
  return moment.utc(longDatetime).format("YYYY-MM-DD");
}

export function GetLocalShortDatetime(longDatetime: string) {
  return moment(longDatetime).format("YYYY-MM-DD");
}

export function GetUTCFromLocalDatetimeInISOString(
  dateType: DateType,
  endOfDay: boolean = false
) {
  var date = moment().local();

  switch (dateType) {
    case DateType.CURRENT:
      return date.utc().toISOString().replace("T", " ").replace("Z", "");
    case DateType.TODAY:
      break;
    case DateType.TOMORROW:
      date = date.add(1, "day");
      break;
    case DateType.YESTERDAY:
      date = date.subtract(1, "day");
      break;
    case DateType.LAST_WEEK_DAY:
      date = date.subtract(6, "day");
      break;
    case DateType.LAST_MONTH_DAY:
      date = date.subtract(1, "month").add(1, "day");
      break;
    case DateType.LAST_YEAR_DAY:
      date = date.subtract(1, "year").add(1, "day");
      break;
    default:
      break;
  }

  if (endOfDay) {
    date = date.endOf("day");
  } else {
    date = date.startOf("day");
  }
  
  return date.utc().toISOString().replace("T", " ").replace("Z", "");
}
